var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-slot",style:({left: _vm.pos.x + 'px', top: _vm.pos.y + 'px'})},[(_vm.slug != null)?_c('card',{attrs:{"slug":_vm.slug}}):_c('div',{staticClass:"card-slot__empty"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }